
import { AxiosInstance } from "axios"
import api from "@/services/api"
import { ViewFullSummary } from "@/types/views/viewSummary"
import { View } from "@/types/views/view"

export class ViewsService {
	public viewSummary: ViewFullSummary | null = null;
	public loading: boolean = false;

	public viewError: any = null;
	public activeViewId: string | null = null;
	public activeView: View | null = null;

	private viewLoadPromise: Promise<ViewFullSummary> | null = null;
	private requestedViewId: string | null = null;

	public async loadViews () {
		if (this.viewLoadPromise && this.requestedViewId === this.activeViewId) {
			await this.viewLoadPromise
			return
		}

		try {
			this.loading = true
			this.viewError = null

			this.requestedViewId = this.activeViewId
			this.viewLoadPromise = api.caseViews(this.activeViewId)
			this.viewSummary = await this.viewLoadPromise
			this.activeView = this.viewSummary!.activeView

			if (this.activeView) {
				this.activeViewId = this.activeView.id
			}
		} catch (err) {
			this.viewError = err
		} finally {
			this.viewLoadPromise = null
			this.requestedViewId = null
		}
		this.loading = false
	}

	public reset () {
		this.viewSummary = null
		this.activeView = null
		this.activeViewId = null
		this.viewLoadPromise = null
		this.requestedViewId = null
	}
}

const viewsService = new ViewsService()
export default viewsService
